import React, { useState } from "react";
import css from "../../style/onboardingweb.module.css";
import { useParams, useHistory } from "react-router";
import { postDocumentsWeb } from "../../store/actions/onboardingActions";
import { toast } from "react-toastify";
import { FaInfoCircle } from "react-icons/fa";
import ErrorComponent from "../../components/ErrorComponent";
import ModalComponent from "../../components/Modals/Modal";

const VehicleRegistration = () => {
  const history = useHistory();
  const { id, type } = useParams();

  const [error, setError] = useState("");
  const [front, setFront] = useState();
  const [frontImg, setFrontImg] = useState();
  const [takePhoto, setTakePhoto] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleAddImage = (e) => {
    if (e?.target?.name === "registrationFile" && e.target.files?.length) {
      setFront(e.target.files[0]);
      setFrontImg(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmitForm = () => {
    if (front) {
      const formData = new FormData();
      formData.append("registrationFile", front);
      postDocumentsWeb(id, type, formData, setError, history);
    } else {
      toast.error("Please upload  your vehicle's registration document.");
    }
  };
  return (
    <div className={css?.mD}>
      <ModalComponent
        text={"Need text for this section from Moovez team!"}
        openState={openModal}
        closeFunction={() => {
          setOpenModal(false);
        }}
        btnText1={"Okay"}
        btnClickFunc1={() => {
          setOpenModal(false);
        }}
        isSmall={true}
      />
      {takePhoto ? (
        <div className={css?.centerDiv}>
          <div className={css?.contentDiv}>
            <label htmlFor="dl-front">
              <div className={css?.dlUploadMd}>
                <h4 className={css?.l2Heading}>Click below to take photo</h4>
                <div className={css?.dlUploadImgBG}>
                  <img
                    src={frontImg ?? "/images/upload.png"}
                    className={css?.dlUploadImg}
                  />
                </div>
              </div>
            </label>
            <input
              id="dl-front"
              name="registrationFile"
              type="file"
              accept="image/*"
              capture="camera"
              onChange={handleAddImage}
              style={{ display: "none" }}
            />
            <ErrorComponent error={error} />
          </div>
          <div className={css?.buttonPanel}>
            <div className={css?.submitButton} onClick={handleSubmitForm}>
              Confirm
            </div>
          </div>
        </div>
      ) : (
        <div className={css?.centerDiv}>
          <div className={css?.contentDiv}>
            <h3 className={css?.mHeading}>
              Take a photo of your Vehicle Registration
            </h3>
            <div className={css?.mtext}>
              Please upload a current (non-expired) photo of your Vehicle
              Registration. Please make sure the license plate and all dates are
              clearly visible.
            </div>
            <div className={css?.infoDiv}>
              <FaInfoCircle
                className={css?.infoIcon}
                onClick={() => {
                  setOpenModal(true);
                }}
              />
              Get more details
            </div>
            <div className={css?.imageDiv}>
              <img src="/images/VR.png" className={css?.dlImage} />
            </div>
          </div>
          <div className={css?.buttonPanel}>
            <div
              className={css?.submitButton}
              onClick={() => setTakePhoto(true)}
            >
              Take Photo
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleRegistration;
